import axios from "axios";
import { GetToken } from "./axios";
import { baseUrl, getRole, urlChatMessage, urlLPJK, urlLinode, urlLinodeAbi } from "./config";


const getIntegrationDetail = (system_id) => {
  let currentListIntegration = JSON.parse(localStorage.getItem('integrationList'));
  let index = currentListIntegration.findIndex(x => x.system_id == system_id);
  return currentListIntegration[index];
}

export const getIntegrationByName = (system_name) => {

  let currentListIntegration = JSON.parse(localStorage.getItem('integrationList'));

  let index = currentListIntegration.findIndex(x => x.system_name == system_name);

  if(index>=0){
    return currentListIntegration[index];
  }

  return null;
}

const getIndexByValue = (array, property, value) => {
  return array.findIndex(x => x[property] == value);
}
export const GetListData = async (strUrl) => {
  let newToken = await GetToken();

  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      url: baseUrl + strUrl,
      headers: {
        "Content-Type": "aplication/json",
        Authorization: "Bearer" + " " + newToken.secret_key,
      },
    };
    axios(config)
      .then((res) => {
        if (res.data.responseStatus === "SUCCESS") {
          resolve(res.data);

          return;
        }
        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};

export const GetListDataCustomUrl =async (strUrl) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      url: strUrl,
      headers: {
        "Content-Type": "aplication/json",
      },
    };
    axios(config)
      .then((res) => {
        if (res.status === 200) {
          resolve(res.data);

          return;
        }
        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });

}

export const GetDownloadFileZip = async (strUrl, fileName, ext = 'zip') => {
  const newToken = await GetToken();

  await axios({
    url: baseUrl + strUrl, //your url
    method: 'GET',
    responseType: 'blob', // important
    headers: {
      "Content-Type": "aplication/json",
      Authorization: "Bearer" + " " + newToken.secret_key,
    },
  }).then((response) => {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', `${fileName}.${ext}`); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
  });
};

export const PostDownloadFile = async (strUrl, parameter, fileName, ext = 'zip') => {
  const newToken = await GetToken();

  await axios({
    url: baseUrl + strUrl, //your url
    method: 'POST',
    responseType: 'blob', // important
    headers: {
      "Content-Type": "aplication/json",
      Authorization: "Bearer" + " " + newToken.secret_key,
    },
    data: parameter,
  }).then((response) => {
      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', `${fileName}.${ext}`); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
  });
};


export const newGetListIntegration = async (system_id, url) => {
  let integrationData = await getIntegrationDetail(system_id);
  let index = await getIndexByValue(integrationData.auth_parameter, 'key', 'token');
  let config = {
    method:'get',
    url:integrationData.url + url,
    headers:{
      "Content-type": 'application/json'
    }
  }

  if(integrationData.auth_type!="Basic Auth"){

  }else{
    if(index >= 0){
      config.headers['token'] = integrationData.auth_parameter[index].value;
    }
  }

  // console.log("cek config", config)

  return new Promise((resolve, reject) => {
    axios(config).then((res) => {
      if (res.status == 200 || res.data.status == "success") {
          resolve(res.data);
          return;
      }
      reject(res.data);
    }).catch((e) => {
      reject(e.response)
    })
  })

}
export const GetListIntegration = async (strUrl) => {
  let newToken = await GetToken();
  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      url: urlLPJK + strUrl,
      headers: {
        "Content-Type": "aplication/json",
        token: newToken.tokenIntegrate,
      },
    };
    axios(config)
      .then((res) => {
        // console.log("cek res", res.status);
        if (res.status == 200 || res.data.status == "success") {
          // console.log(res.data)
          resolve(res.data);
          return;
        }
        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};
export const GetListDataMessage = async (strUrl) => {
  let newToken = await GetToken();

  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      url: urlChatMessage + strUrl,
      headers: {
        "Content-Type": "aplication/json",
        Authorization: "Bearer" + " " + newToken.secret_key,
      },
    };
    axios(config)
      .then((res) => {
        if (res.data.responseStatus === "SUCCESS") {
          resolve(res.data);

          return;
        }
        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};

export const insertFormData = async (strUrl, body) => {
  let newToken = await GetToken();
  return new Promise((resolve, reject) => {
    const config = {
      method: "post",
      url: baseUrl + strUrl,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${newToken.secret_key}`,
        "Content-Type": "multipart/form-data",
      },
      data: body,
    };
    axios(config)
      .then((res) => {
        if (res.data.responseStatus === "SUCCESS") {
          resolve(res.data);
          return;
        }

        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};
export const newPostIntegration = async (system_id, url, body) => {
  let integrationData = await getIntegrationDetail(system_id);
  let index = await getIndexByValue(integrationData.auth_parameter, 'key', 'token');
  let config = {
    method:'post',
    url:integrationData.url + url,
    headers:{
      "Content-type": 'application/json'
    },
    data: body
  }

  if(integrationData.auth_type!="Basic Auth"){

  }else{
    if(index >= 0){
      config.headers['token'] = integrationData.auth_parameter[index].value;
    }
  }

  return new Promise((resolve, reject) => {
    axios(config)
      .then((res) => {
        if (res.data.status === "success") {
          resolve(res.data);

          return;
        }
        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
}
export const postIntegration = async (strUrl, body) => {
  let newToken = await GetToken();

  return new Promise((resolve, reject) => {
    const config = {
      method: "post",
      url: urlLPJK + strUrl,
      headers: {
        "Content-Type": "aplication/json",
        token: newToken.tokenIntegrate,
      },
      data: body,
    };
    axios(config)
      .then((res) => {
        if (res.data.status === "success") {
          resolve(res.data);

          return;
        }
        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};
// lsp_id/certificate/user_id/schema_name/file_sertifikat
export const insertData = async (strUrl, body) => {
  let newToken = await GetToken();
  return new Promise((resolve, reject) => {
    const config = {
      method: "post",
      url: baseUrl + strUrl,
      headers: {
        "Content-Type": "aplication/json",
        'Access-Control-Allow-Origin': '*',
        Authorization: `Bearer ${newToken.secret_key}`,
      },
      data: body,
    };
    axios(config)
      .then((res) => {
        if (res.data.responseStatus === "SUCCESS") {
          resolve(res.data);
          return;
        }

        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};

// export const EditData = async (strUrl, body) => {
//   let newToken = await GetToken();
//   return new Promise((resolve, reject) => {
//     axios({
//       method: "PUT",
//       url: baseUrl + strUrl,
//       headers: {

//         "Content-Type": "aplication/json",
//         Authorization: `Bearer ${newToken.secret_key}`,
//       },
//       data: body,
//     })
//       .then((res) => {
//         if (res.data.responseStatus === "SUCCESS") {
//           resolve(res.data);
//           return;
//         }

//         reject(res.data);
//       })
//       .catch((e) => {
//         reject(e.response);
//       });
//   });
// };

export const inputDataNew = async (strUrl, body) => {
  let newToken = await GetToken();
  return new Promise((resolve, reject) => {
    axios({
      method: "POST",
      url: `${baseUrl}${strUrl}`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${newToken.secret_key}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(body),
    })
      .then((res) => {
        if (res.data.responseStatus === "SUCCESS") {
          resolve(res.data);
          return;
        }

        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};
export const inputChat = async (strUrl, body) => {
  let newToken = await GetToken();
  return new Promise((resolve, reject) => {
    axios({
      method: "POST",
      url: urlChatMessage + strUrl,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${newToken.secret_key}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(body),
    })
      .then((res) => {
        if (res.data.responseStatus === "SUCCESS") {
          resolve(res.data);
          return;
        }

        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};
export const editChat = async (strUrl, body) => {
  let newToken = await GetToken();
  return new Promise((resolve, reject) => {
    axios({
      method: "PUT",
      url: urlChatMessage + strUrl,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${newToken.secret_key}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(body),
    })
      .then((res) => {
        if (res.data.responseStatus === "SUCCESS") {
          resolve(res.data);
          return;
        }

        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};
export const EditData = async (strUrl, body) => {
  let newToken = await GetToken();
  return new Promise((resolve, reject) => {
    axios({
      method: "PUT",
      url: `${baseUrl}${strUrl}`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${newToken.secret_key}`,
        "Content-Type": "application/json",
      },
      data: JSON.stringify(body),
    })
      .then((res) => {
        if (res.data.responseStatus === "SUCCESS") {
          resolve(res.data);
          return;
        }

        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};

export const DeleteData = async (strUrl) => {
  let newToken = await GetToken();
  return new Promise((resolve, reject) => {
    axios({
      method: "DELETE",
      url: baseUrl + strUrl,
      headers: {
        "Content-Type": "aplication/json",
        Authorization: `Bearer ${newToken.secret_key}`,
      },
    })
      .then((res) => {
        if (res.data.responseStatus === "SUCCESS") {
          resolve(res.data);
          return;
        }

        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};
export const DeleteChat = async (strUrl, body) => {
  let newToken = await GetToken();

  return new Promise((resolve, reject) => {
    axios({
      data: JSON.stringify(body),
      method: "DELETE",
      url: urlChatMessage + strUrl,
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
        Authorization: `Bearer ${newToken.secret_key}`,
      },
    })
      .then((res) => {
        if (res.data.responseStatus === "SUCCESS") {
          resolve(res.data);
          return;
        }

        reject(res.data);
      })
      .catch((e) => {
        reject(e.response);
      });
  });
};

export const refreshToken = () => {
  const setLocalStorage = (responseJSON) => {
    localStorage.setItem("secret_key", responseJSON.secret_key);
  };
  const data = {};
  const token = localStorage.getItem("secret_key");
  data["token"] = token;

  insertData("/users/refresh_token", data)
    .then((response) => {
      let responseJSON = response;
      if (response.responseStatus === "SUCCESS") {
        setLocalStorage(responseJSON);
        window.location.reload();
      }
    })
    .catch((error) => {
      localStorage.clear();
      window.location.reload();
    });
};

export const formatRupiah = (angka) => {
  var number_string = angka.replace(/[^,\d]/g, '').toString(),
  split   		= number_string.split(','),
  sisa     		= split[0].length % 3,
  rupiah     		= split[0].substr(0, sisa),
  ribuan     		= split[0].substr(sisa).match(/\d{3}/gi);

  // tambahkan titik jika yang di input sudah menjadi angka ribuan
  if(ribuan){
    let separator = sisa ? '.' : '';
    rupiah += separator + ribuan.join('.');
  }

  rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
  return 'Rp '+rupiah;
}

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export const replaceAll = (str, find, replace) => {
  return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

export const concatTwoUrl = (firstUrl, secondUrl) => {
  if(!secondUrl){
    return '#';
  }

  if(!firstUrl){
    return '#';
  }

  if(secondUrl.startsWith('/')){
    secondUrl = removeCharAt(secondUrl, 'first');
  }

  if(firstUrl.endsWith('/')){
    firstUrl = removeCharAt(firstUrl);
  }

  return firstUrl+'/'+secondUrl;
}

export const handleUrlFile = (url = '') => {
  if(!url){
    return url;
  }

  if(typeof url === 'string' || url instanceof String){
    if(url.includes('https') || url.includes('perizinan')){
      return url;
    }
  }

  let newBaseUrl = deleteSlashBase(urlLinode);

  if (getRole() === 'APL') {
    const lsp_id = localStorage.getItem('lsp_id');
    if (lsp_id === "cff88759-27e6-4708-8097-27ed283505b9"){
      newBaseUrl = deleteSlashBase(urlLinodeAbi);
    }
  } else {
    const lsp_id = JSON.parse(localStorage.getItem('ref_id'));
    if (lsp_id === "cff88759-27e6-4708-8097-27ed283505b9"){
      newBaseUrl = deleteSlashBase(urlLinodeAbi);
    }
  }

  
  let newPathFile = '';
  
  if(url){
    newPathFile = deleteSlashPath(url);
  }
  
  
  return newBaseUrl+'/'+newPathFile;
}

const deleteSlashBase = (valueUrl) => {
  let newBaseUrl = valueUrl;
  let slash = valueUrl.endsWith("/");

  if(slash){
    newBaseUrl = removeCharAt(newBaseUrl)
  }

  return newBaseUrl
}

const deleteSlashPath = (valuePath) => {
  let newBaseUrl = valuePath;

  let slash = '';

  try {
    slash = valuePath.startsWith("/");
  } catch (err) {
    slash = "";
  }
  

  if(slash){
    newBaseUrl = removeCharAt(newBaseUrl, 'first');
  }

  return newBaseUrl
}

export const deleteSlashTwo = (urlLeft, urlRight) => {
  let newLeft = "";
  let newRight = "";

  if(urlLeft){
    newLeft = deleteSlashBase(urlLeft);
  }

  if(urlRight){
    newRight = deleteSlashPath(urlRight);
  }

  return newLeft+"/"+newRight;
}

const removeCharAt = (val, pos=null) => {
  var tmp = val.split(''); // convert to an array
  if(pos==='first'){
    tmp.shift();
  }else{
    tmp.pop();
  }
  return tmp.join(''); // reconstruct the string
}

export const hasPropertyWithValue = (array, propertyName, propertyValue) => {
  return array.some(item => item[propertyName] === propertyValue);
}

export const formatFullIndoDate = (currentDate) => {
  const date = new Date(currentDate);

  const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
  const months = [
    'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
    'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
  ];

  const formattedDate = `
    ${days[date.getDay()]}, 
    ${date.getDate()} 
    ${months[date.getMonth()]} 
    ${date.getFullYear()}
  `;

  return formattedDate;
  // kamis, 28 Agustus 2020
}

export const getFileExtension = (filename) => {
  return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
}

export const isImage= (filename) => {
  const imageExtensions = ['png', 'jpg', 'jpeg']; // Tambahkan ekstensi lain jika diperlukan
  const fileExtension = filename.split('.').pop().toLowerCase();

  return imageExtensions.includes(fileExtension);
}

export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}